import styleInject from 'style-inject';

var css_248z = ".Tooltip-module_tooltip__UA7H9 {\n\tbackground-color: var(--qd-color-tooltip-bg);\n\tborder-radius: var(--qd-border-radius);\n\tbox-shadow: var(--qd-dialog-shadow);\n\ttransition: opacity 0.2s;\n\tpadding: 8px 12px;\n\tmax-width: 450px;\n\n\tposition: absolute;\n\tz-index: 1000;\n\tpointer-events: none;\n}\n\n.Tooltip-module_lowerMsg__iT2IR {\n\tmargin: 5px 0 0;\n}\n";
var styles = {"tooltip":"Tooltip-module_tooltip__UA7H9","lowerMsg":"Tooltip-module_lowerMsg__iT2IR"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
